import Image from 'next/image'

import styles from './style.module.scss'

export default function ErrorText({ errorMessage, containerStyle }) {
  const ErrorIcon = () => (
    <Image
      src="https://boards.cdn.greenhouse.io/assets/svg/error-69893c3b3f8f27477ac24dbcb3d8e569fcc265882e77cd464d2bad69dd7d3918.svg"
      alt="Error"
      className="error-icon"
      width={17}
      height={17}
    />
  )

  return (
    <div className={styles.error_message_container} style={containerStyle}>
      <ErrorIcon />
      <span className={styles.error_message}>{errorMessage}</span>
    </div>
  )
}
